import script from "./battery.vue?vue&type=script&setup=true&lang=js"
export * from "./battery.vue?vue&type=script&setup=true&lang=js"

import "./battery.vue?vue&type=style&index=0&id=aa145e18&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa145e18"]])

export default __exports__